import { Component, h } from 'preact';
import { DivCat, PropertyCategory, Location } from '../../../../types';
import { DivCatUtils } from '../../../../core/div-cat-utils';

interface ResultsCategoryToggleProps {
  divCat: DivCat;
  locationPermalink: string;
  onCategoryChange?: (divCat: DivCat) => any;
}

interface ResultsCategoryToggleState {
  category: PropertyCategory
}

export class ResultsCategoryToggle extends Component<ResultsCategoryToggleProps, ResultsCategoryToggleState> {
  divCatUtils = new DivCatUtils();

  constructor(props: ResultsCategoryToggleProps) {
    super(props);

    this.setState({
      category: props.divCat.category
    });
  }

  getButtonClasses(active: boolean) {
    if (active) {
      return 'btn btn-dark text-white';
    } else {
      return 'btn btn-outline-dark';
    }
  }

  getHref(divCat: DivCat, locPath: string) {
    const typeCatSlug = this.divCatUtils.toSlug(divCat);

    return `/${typeCatSlug}${locPath}`
  }

  getRentHref(props: ResultsCategoryToggleProps, locPath: string) {
    const divCat = Object.assign({}, props.divCat) as DivCat;
    divCat.category = 'Rent';
    return this.getHref(divCat, locPath);
  }

  getSaleHref(props: ResultsCategoryToggleProps, locPath: string) {
    const divCat = Object.assign({}, props.divCat) as DivCat;
    divCat.category = 'Sale';
    return this.getHref(divCat, locPath);
  }

  categoryChanged(props: ResultsCategoryToggleProps, category: PropertyCategory) {
    const divCat: DivCat = {
      division: props.divCat.division,
      category: category,
      type: props.divCat.type,
    }

    props.divCat.category = category;
    this.setState({
      category: category
    });

    if (props.onCategoryChange) {
      props.onCategoryChange(divCat);
    }
  }

  getMobileControls(props: ResultsCategoryToggleProps, state) {
    return (
      <div class="btn-group d-flex d-lg-none" role="group">
        <button class={this.getButtonClasses(props.divCat.category === 'Sale')}
            onClick={() => this.categoryChanged(props, 'Sale')}>
          <span class="d-none d-xl-inline">For sale</span>
          <span class="d-inline d-xl-none">Buy</span>
        </button>
        <button class={this.getButtonClasses(props.divCat.category === 'Rent')}
            onClick={() => this.categoryChanged(props, 'Rent')}>
          <span class="d-none d-xl-inline">For rent</span>
          <span class="d-inline d-xl-none">Rent</span>
        </button>
      </div>
    );
  }

  getBiggerScreenControls(props: ResultsCategoryToggleProps, state) {
    return (
      <div class="btn-group d-none d-lg-flex" role="group">
        <a href={this.getSaleHref(props, props.locationPermalink)} class={this.getButtonClasses(props.divCat.category === 'Sale')}
            onClick={() => this.categoryChanged(props, 'Sale')}>
          <span class="d-none d-xl-inline">For sale</span>
          <span class="d-inline d-xl-none">Buy</span>
        </a>
        <a href={this.getRentHref(props, props.locationPermalink)} class={this.getButtonClasses(props.divCat.category === 'Rent')}
            onClick={() => this.categoryChanged(props, 'Rent')}>
          <span class="d-none d-xl-inline">For rent</span>
          <span class="d-inline d-xl-none">Rent</span>
        </a>
      </div>
    );
  }

  render(props: ResultsCategoryToggleProps, state) {
    return (
      <div>
        { this.getMobileControls(props, state) }
        { this.getBiggerScreenControls(props, state) }
      </div>
    )
  }
}